module.exports = __webpack_public_path__ + "static/img/carpic_2.63a3abd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carpic_2.png
// module id = 753
// module chunks = 1